import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../images/logo5.png";
import { Button } from "./Button/Button";

function Navbar() {
    const top = () => {
        window.scrollTo(0, 0);
    };

    const [color, setColor] = useState(false);
    const [drop, setDrop] = useState(false);
    const [click, setClick] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const changeColor = () => {
            setColor(window.scrollY >= 90);
        };

        changeColor();
        window.addEventListener("scroll", changeColor);

        return () => window.removeEventListener("scroll", changeColor);
    }, []);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDrop(false);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);

        return () => document.removeEventListener("mousedown", handleOutsideClick);
    }, []);

    const handleDrop = () => setDrop(!drop);
    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const onClickEvent = () => {
        top();
        setDrop(false);
        closeMobileMenu();
    };

    return (
        <nav className={color ? "navbar navbar-bg" : "navbar"}>
            <div className="navbar-container">
                <Link to="/" className="navbar-logo" onClick={onClickEvent}>
                    <img
                        className="logo"
                        src={logo}
                        alt="Mico Design and Consulting logo"
                        path="/"
                    />
                </Link>
                <div
                    className="menu-icon"
                    onClick={handleClick}
                    aria-label="Toggle navigation menu"
                    role="button"
                    tabIndex={0}
                    onKeyDown={(event) => {
                        if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            handleClick();
                        }
                    }}
                >
                    <i className={click ? "fas fa-times" : "fas fa-bars"} />
                </div>
                <ul className={click ? "nav-menu active" : "nav-menu"}>
                    <li className="nav-item">
                        <Link to="/" className="nav-links" onClick={onClickEvent}>
                            Home
                        </Link>
                    </li>
                    <li className="nav-item nav-item-dropdown" ref={dropdownRef}>
                        <button
                            type="button"
                            className="nav-links dropdown-item dropdown-trigger"
                            onClick={handleDrop}
                        >
                            <span>Create</span>
                            <i
                                className={drop ? "fas fa-caret-up" : "fas fa-caret-down"}
                                style={{ marginLeft: "5px" }}
                            />
                        </button>
                        {drop && (
                            <ul className={`dropdown-menu ${drop ? "show" : ""}`}>
                                <Link
                                    to="/pools"
                                    className="dropdown-links"
                                    onClick={onClickEvent}
                                >
                                    Pools
                                </Link>

                                <Link
                                    to="/patio"
                                    className="dropdown-links"
                                    onClick={onClickEvent}
                                >
                                    Patio
                                </Link>

                                <Link
                                    to="/kitchen"
                                    className="dropdown-links"
                                    onClick={onClickEvent}
                                >
                                    Kitchen
                                </Link>

                                <Link
                                    to="/yardscape"
                                    className="dropdown-links"
                                    onClick={onClickEvent}
                                >
                                    Yardscape
                                </Link>
                            </ul>
                        )}
                    </li>
                    <li className="nav-item">
                        <Link
                            to="/gallery"
                            className="nav-links"
                            onClick={onClickEvent}
                        >
                            Gallery
                        </Link>
                    </li>

                    <li className="nav-cta">
                        <Button
                            className="btns"
                            buttonStyle="btn--outline"
                            buttonSize="btn--small"
                            buttonLink="/contact"
                            onClick={onClickEvent}
                        >
                            Get In Touch
                        </Button>
                    </li>
                </ul>
            </div>
        </nav>
    );
}

export default Navbar;
